export default __webpack_public_path__ + "8f695fc2022c9871bcc4072242b88d70.svg";